import { render, staticRenderFns } from "./SmsBestaetigung.vue?vue&type=template&id=69644549&scoped=true&"
import script from "./SmsBestaetigung.vue?vue&type=script&lang=js&"
export * from "./SmsBestaetigung.vue?vue&type=script&lang=js&"
import style0 from "./SmsBestaetigung.vue?vue&type=style&index=0&id=69644549&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69644549",
  null
  
)

export default component.exports